export default "__VITE_ASSET__KoFvnCKM__"